<template>
  <div class="back_to_top">
    <div class="pic">
      <a href="" uk-scroll title="回到網頁頂端" role="button">
        <img src="../../img/back_to_top.svg" alt="回到網頁頂端" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoToTop",
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.back_to_top {
  @include md {
    display: none;
  }
  position: fixed;
  bottom: 50px;
  right: 18px;
  text-align: right;
  z-index: 80;
  .pic {
    display: inline-block;
    width: auto;
    border-radius: 50px;
    padding: 10px;
    @include main_bgcolor();
  }
}
</style>
